// extracted by mini-css-extract-plugin
module.exports = {"board":"board_board__3a-AI","board_wrapper":"board_board_wrapper__16uu1"};